<template>
  <div class="shop-form__block" >
    <span
      class="button grey"
      v-for="(
        sortedItemType, sortedItemName
      ) in currentLoyalityKind === 'certificate' ? sortedLoyalityByName.certificates : sortedLoyalityByName.abonements"
      :key="sortedItemType.id"
      @click="setLoyality(sortedItemName)"
      :class="{
        active: sortedItemName === (currentLoyalityKind === 'certificate' ? currentCertificateName : currentAbonementName)
      }"
      >{{ sortedItemType.title }}</span
    >
  </div>
</template>

<script lang="ts" setup>
import { computed } from "vue";
import { useStore } from "vuex";
import { TypeLoyalityKinds } from "@/types";
import {
  IloyalityShopData,
  TypeReceiver,
  TypeSortedLoyalityByName,
} from "@/types/typesOfState";
import { Store } from "vuex";

const store = useStore();

const loyalityShopData = computed<IloyalityShopData>(
  () => store.state.loyalityShopData
);
const currentLoyalityKind = computed<TypeLoyalityKinds>(
  () => store.state.currentLoyalityKind
);

const sortedLoyalityByName = computed<TypeSortedLoyalityByName>(
  () => store.state.sortedLoyalityByName
);

const currentCertificateName = computed<string>(
  () => store.state.loyalityShopData.byCertificate.name
);
const currentAbonementName = computed<string>(
  () => store.state.loyalityShopData.byAbonement.name
);

function setLoyality(loyalityName: string): void {
  if (currentLoyalityKind.value === 'certificate') {
    store.state.loyalityShopData.byCertificate.name = loyalityName;
    const currentSortedLoyalityByName = store.state.sortedLoyalityByName.certificates[loyalityName]
    if (currentSortedLoyalityByName.list.length === 1) {
      
      store.state.loyalityShopData.buyLoyalityType = currentSortedLoyalityByName.list[0].id
      store.state.loyalityShopData.byCertificate.seanceLength = currentSortedLoyalityByName.minutesArray[0]
      store.state.loyalityShopData.byCertificate.nominal = currentSortedLoyalityByName.nominalsArray[0]
    }
  } else {
    store.state.loyalityShopData.byAbonement.name = loyalityName;
  }
  
}
</script>

<style></style>
